(function ($, Drupal) {

  'use strict';

  function handleRfiClick(event, aid) {
    const destination = $("#" + aid);

    if (destination.length) {
      var desktopSize = 992;
      if($(event.currentTarget).is("#navRFI") && window.innerWidth < desktopSize) {
        $('.navbar-toggler').trigger('click');
      }
    } else {
      event.preventDefault();
      window.location.href = '/request-info';
    }
  }

  function onDocRfiClicksReady(context) {
    const $elements = $(once('initRfiClickBehavior', 'body', context));
    $elements.each(function() {

      $('.infolink').click(function(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'gtm.linkClick',
          'category': 'call to action',
          'label': '#getstartedform',
          'action': 'Request Info - Header'
        });

        handleRfiClick(event, 'getstartedform');
      });
    });
  }

  Drupal.behaviors.initRfiClick = {
    attach: function (context) {
      onDocRfiClicksReady();
    }
  };

})(jQuery, Drupal);
